import { createRequest } from "helpers/tools";

export const getSourceDetail = async (id) => {
    return await createRequest({
        suffix: `sources/${id}`,
        handleError: true,
        method: "get",
    });
};